/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import { SerializedLegacyFilter } from 'cio/types/conditions/legacy-filter';
import { Filters } from 'cio/utils/filters';
import EnvironmentService from 'cio/services/environment';
import CampaignModel from 'cio/models/campaign';

interface ActionConditionsArgs {
  actionAbstract: {
    action: ActionModel;
    [key: string]: any;
  };
  isSaving: boolean;
  onSetConditions: (conditions: SerializedLegacyFilter[] | Filters) => void;
  hasReadOnlyPermission: boolean;
}

export default class ActionConditions extends Component<ActionConditionsArgs> {
  @service environment!: EnvironmentService;
  @service features!: FeaturesService;

  get campaign() {
    return this.args.actionAbstract.action.belongsTo('campaign').value() as CampaignModel | null;
  }

  get _conditionTypes() {
    if (this.isOnlyEventAttributeEnabled) {
      return ['event_attribute'];
    }

    let conditionsTypes = ['attribute', 'event_attribute', 'event', 'segments_negatable', 'message'];

    if (this.shouldIncludeDeviceCondition) {
      conditionsTypes.push('device_attribute');
    }

    return conditionsTypes;
  }

  get isOnlyEventAttributeEnabled() {
    return this.campaign?.isWebhookTriggered ?? false;
  }

  get shouldIncludeDeviceCondition() {
    return this.environment.enabledAction('push');
  }
}
